import { Data, Settings as SettingsModule, Utils } from 'common';
import React from 'react';

const { CalculatedData } = Data;
const { SettingsContent, SettingsIdentifiers } = SettingsModule;
const { Session, Util } = Utils;

const SettingsWrapper = () => {
	const { AllowedTargetOrigin, IsInWinClient } = Session.getSettings();

	CalculatedData.init(); // initialize allServices array for ServiceOptionsView

	const completionCallback = data => {
		if (IsInWinClient) {
			window.close();
		} else {
			try {
				Util.postMessage(data, AllowedTargetOrigin);
			} catch (error) {
				console.log(error);
			}
		}
	};

	const convertRouteToActiveTab = () => {
		if (Util.isInRoute('common/general')) {
			return SettingsIdentifiers.Common.General;
		} else if (Util.isInRoute('common/carriers')) {
			return SettingsIdentifiers.Common.Carriers;
		} else if (Util.isInRoute('common/serviceoptions')) {
			return SettingsIdentifiers.Common.ServiceOptions;
		} else if (Util.isInRoute('common/labelcustomization')) {
			return SettingsIdentifiers.Common.LabelCustomization;
		} else if (Util.isInRoute('mail/general')) {
			return SettingsIdentifiers.Mail.General;
		} else if (Util.isInRoute('mail/printonoptions')) {
			return SettingsIdentifiers.Mail.PrintOnOptions;
		} else if (Util.isInRoute('mail/refundassist')) {
			return SettingsIdentifiers.Mail.RefundAssist;
		} else if (Util.isInRoute('orders/labelmessages')) {
			return SettingsIdentifiers.Orders.LabelMessages;
		} else if (Util.isInRoute('orders/international')) {
			return SettingsIdentifiers.Orders.International;
		} else if (Util.isInRoute('orders/packingslips')) {
			return SettingsIdentifiers.Orders.PackingSlips;
		}

		return null;
	};

	return (
		<div className="account-settings-wrapper common-settings main-view">
			<SettingsContent
				activeTab={convertRouteToActiveTab()}
				completionCallback={completionCallback}
			/>
		</div>
	);
};

export default SettingsWrapper;
